module.exports = __webpack_public_path__ + "img/1.57c5af79.png";